export function getActivityDateRanges(now: Date, days: number) {
  const startDate = new Date(now);
  startDate.setUTCDate(startDate.getUTCDate() - days);

  return {
    startDate: startDate.toISOString().substring(0, 10),
    endDate: now.toISOString().substring(0, 10),
  };
}
